import { TEACHER_WIDGET_TASK_TABS } from '@/homework/values/homeworks.values';

export const TEACHER_PORTAL_WIDGETS = {
  HOMEWORKS_AND_COURSES: {
    code: 'HOMEWORKS_AND_COURSES',
    value: 'full-screen--homeworks-courses'
  },
  CALENDAR_AND_MEETINGS: {
    code: 'CALENDAR_AND_MEETINGS',
    value: 'full-screen--calendar-meetings'
  }
}

export const TEACHER_PORTAL_KEYS = {
  TAB: 'ED_TEACHER_PORTAL_TAB',
  COURSE_TAB: 'COURSE_TAB',
  TASKS_TAB: 'TASKS_TAB',
  COURSE_OBJ: 'courseObj',
  COURSE_ID: 'courseId',
  TASKS_HOMEWORKS_TAB: 'ED_TASKS_HOMEWORKS_TAB',
  TASKS_HOMEWORKS_STUDENTS_TAB: TEACHER_WIDGET_TASK_TABS.BY_STUDENT,
  TASKS_HOMEWORKS_SECTIONS_TAB: TEACHER_WIDGET_TASK_TABS.BY_SECTIONS,
  TASKS_COURSE_ID: 'ED_TASKS_COURSE_ID',
  TASKS_HOMEWORK_ID: 'ED_TASKS_HOMEWORK_ID',
}